var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "saas_module_plate",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 企业添加了SaaS活动板块，要展示活动列表时可选用该组件 "),
      ]),
      _c(
        "el-form-item",
        { staticClass: "type_wrap", attrs: { prop: "style" } },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.style,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "style", $$v)
                    },
                    expression: "value.config.style",
                  },
                },
                _vm._l(_vm.typeList, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "type_box" },
                    [
                      _c("el-image", {
                        staticClass: "img",
                        attrs: { src: item.imageurl, fit: "contain" },
                        on: {
                          click: function (_) {
                            return (_vm.value.config.style = item.id)
                          },
                        },
                      }),
                      _c("el-radio", { attrs: { label: item.id } }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
      _c("el-form-item", { attrs: { prop: "title_bar_image" } }, [
        _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "upload" },
            [
              _c("upload-file", {
                ref: "uploadBanner",
                attrs: {
                  "link-url": _vm.linkUrl,
                  canDel: Boolean(_vm.value.config.title_bar_image),
                  tempurl: _vm.value.config.title_bar_image,
                  uploadInfo: _vm.uploadInfo,
                  deletePadding: true,
                },
                on: {
                  emitUploadFile: function (val) {
                    return _vm.emitUploadFile(val, "title_bar_image")
                  },
                  onDelete: function ($event) {
                    return _vm.handleDelUpload("title_bar_image")
                  },
                },
              }),
              _c(
                "div",
                { staticClass: "upload-item-wrap" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onUpload("uploadBanner")
                        },
                      },
                    },
                    [_vm._v(" 上传图片 ")]
                  ),
                  _vm.pictureList.length > 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.selectPicture("title_bar_image")
                            },
                          },
                        },
                        [_vm._v(" 选择图片 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-form-item",
        { attrs: { prop: "title" } },
        [
          _c("div", { staticClass: "title" }, [_vm._v("顶部标题")]),
          _c("el-input", {
            attrs: { placeholder: "请输入顶部标题", clearable: "" },
            model: {
              value: _vm.value.config.title,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "title", $$v)
              },
              expression: "value.config.title",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
            _vm._v("顶部标题字号和颜色"),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "字号" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.title_font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "title_font_size", $$v)
                  },
                  expression: "value.config.title_font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "色值" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.title_font_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "title_font_color", $$v)
                  },
                  expression: "value.config.title_font_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "module_plate_id" } },
        [
          _c("div", { staticClass: "title" }, [_vm._v("展示的SaaS活动板块")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择板块",
                clearable: "",
                filterable: "",
              },
              on: { change: _vm.changeModule },
              model: {
                value: _vm.value.config.module_plate_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "module_plate_id", $$v)
                },
                expression: "value.config.module_plate_id",
              },
            },
            _vm._l(_vm.moduleList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.value.config.style == "2"
        ? _c("el-form-item", { attrs: { prop: "prefix_icon" } }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("活动名称旁图标（选填）"),
            ]),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "upload" },
                [
                  _c("upload-file", {
                    ref: "uploadIcon",
                    attrs: {
                      "link-url": _vm.linkUrl,
                      canDel: Boolean(_vm.value.config.prefix_icon),
                      tempurl: _vm.value.config.prefix_icon,
                      uploadInfo: _vm.uploadInfo,
                      deletePadding: true,
                    },
                    on: {
                      emitUploadFile: function (val) {
                        return _vm.emitUploadFile(val, "prefix_icon")
                      },
                      onDelete: function ($event) {
                        return _vm.handleDelUpload("prefix_icon")
                      },
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "upload-item-wrap" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.onUpload("uploadIcon")
                            },
                          },
                        },
                        [_vm._v(" 上传图片 ")]
                      ),
                      _vm.pictureList.length > 0
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectPicture("prefix_icon")
                                },
                              },
                            },
                            [_vm._v(" 选择图片 ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        [
          _c("div", { staticStyle: { "margin-bottom": "5px" } }, [
            _vm._v("活动名称字号和颜色"),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "字号" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 0 },
                model: {
                  value: _vm.value.config.activity_name_font_size,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "activity_name_font_size", $$v)
                  },
                  expression: "value.config.activity_name_font_size",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "色值" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.value.config.activity_name_font_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "activity_name_font_color", $$v)
                  },
                  expression: "value.config.activity_name_font_color",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "activity_num" } },
        [
          _c("div", { staticClass: "activity_num" }, [
            _vm._v("展示的活动个数"),
          ]),
          _c("el-input", {
            attrs: { placeholder: "请输入个数", clearable: "" },
            model: {
              value: _vm.value.config.activity_num,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "activity_num", $$v)
              },
              expression: "value.config.activity_num",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }